"use strict";
/**
 * Icons
 *
 * @author Dominique Rau [domi.github@gmail.com](mailto:domi.github@gmail.com)<br/>
 * @version 0.0.1
 */
// Generated by gulp icon - do not modify manually
// tslint:disable:max-line-length
// tslint:disable:cyclomatic-complexity
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
var React = __importStar(require("react"));
var agv_1 = __importDefault(require("./devices/agv"));
var agvSmall_1 = __importDefault(require("./devices/agvSmall"));
var android_1 = __importDefault(require("./devices/android"));
var apple_1 = __importDefault(require("./devices/apple"));
var arduino_1 = __importDefault(require("./devices/arduino"));
var blebox4_1 = __importDefault(require("./devices/blebox4"));
var blebox6_1 = __importDefault(require("./devices/blebox6"));
var bleRemote_1 = __importDefault(require("./devices/bleRemote"));
var bleRemote2_1 = __importDefault(require("./devices/bleRemote2"));
var bulb_hue_1 = __importDefault(require("./devices/bulb_hue"));
var bulb_lifx_1 = __importDefault(require("./devices/bulb_lifx"));
var bulb_1 = __importDefault(require("./devices/bulb"));
var coffeeMachine_1 = __importDefault(require("./devices/coffeeMachine"));
var conveyorBelt_1 = __importDefault(require("./devices/conveyorBelt"));
var desk_1 = __importDefault(require("./devices/desk"));
var devBoard_1 = __importDefault(require("./devices/devBoard"));
var dimmer_1 = __importDefault(require("./devices/dimmer"));
var dimmerOld_1 = __importDefault(require("./devices/dimmerOld"));
var dishwasher_1 = __importDefault(require("./devices/dishwasher"));
var doorSensor_1 = __importDefault(require("./devices/doorSensor"));
var drone_1 = __importDefault(require("./devices/drone"));
var echo_1 = __importDefault(require("./devices/echo"));
var echoDot_1 = __importDefault(require("./devices/echoDot"));
var esp_1 = __importDefault(require("./devices/esp"));
var fan_1 = __importDefault(require("./devices/fan"));
var firmata_1 = __importDefault(require("./devices/firmata"));
var fridge_1 = __importDefault(require("./devices/fridge"));
var genericDimmer_1 = __importDefault(require("./devices/genericDimmer"));
var genericSwitch_1 = __importDefault(require("./devices/genericSwitch"));
var googleHomeMini_1 = __importDefault(require("./devices/googleHomeMini"));
var haefeleHub_1 = __importDefault(require("./devices/haefeleHub"));
var hueBridge_1 = __importDefault(require("./devices/hueBridge"));
var hueDimmerRemote_1 = __importDefault(require("./devices/hueDimmerRemote"));
var hueLightSwitch_1 = __importDefault(require("./devices/hueLightSwitch"));
var ioLink_1 = __importDefault(require("./devices/ioLink"));
var kettle_1 = __importDefault(require("./devices/kettle"));
var KNX_1 = __importDefault(require("./devices/KNX"));
var lampDesk_1 = __importDefault(require("./devices/lampDesk"));
var lampStand_1 = __importDefault(require("./devices/lampStand"));
var lampTable_1 = __importDefault(require("./devices/lampTable"));
var lampTable2_1 = __importDefault(require("./devices/lampTable2"));
var lampWall_1 = __importDefault(require("./devices/lampWall"));
var ledband_1 = __importDefault(require("./devices/ledband"));
var lightingPadRound_1 = __importDefault(require("./devices/lightingPadRound"));
var lightingPadRoundDirect_1 = __importDefault(require("./devices/lightingPadRoundDirect"));
var lightingPadRoundIndirect_1 = __importDefault(require("./devices/lightingPadRoundIndirect"));
var lightingPadSquare_1 = __importDefault(require("./devices/lightingPadSquare"));
var lightingPadSquareDirect_1 = __importDefault(require("./devices/lightingPadSquareDirect"));
var lightingPadSquareIndirect_1 = __importDefault(require("./devices/lightingPadSquareIndirect"));
var lock_1 = __importDefault(require("./devices/lock"));
var lockOpen_1 = __importDefault(require("./devices/lockOpen"));
var lockTime_1 = __importDefault(require("./devices/lockTime"));
var meshbox2wire_1 = __importDefault(require("./devices/meshbox2wire"));
var meshboxEco_1 = __importDefault(require("./devices/meshboxEco"));
var meshboxEco1MW_1 = __importDefault(require("./devices/meshboxEco1MW"));
var meshboxEcoMW_1 = __importDefault(require("./devices/meshboxEcoMW"));
var meshboxEcoRGB_1 = __importDefault(require("./devices/meshboxEcoRGB"));
var meshThing_1 = __importDefault(require("./devices/meshThing"));
var meshthingNotification_1 = __importDefault(require("./devices/meshthingNotification"));
var microsoft_1 = __importDefault(require("./devices/microsoft"));
var microwave_1 = __importDefault(require("./devices/microwave"));
var mixer_1 = __importDefault(require("./devices/mixer"));
var motionSensor_1 = __importDefault(require("./devices/motionSensor"));
var motorElectric_1 = __importDefault(require("./devices/motorElectric"));
var movementSensor_1 = __importDefault(require("./devices/movementSensor"));
var MQTT_1 = __importDefault(require("./devices/MQTT"));
var multisensorPCB_1 = __importDefault(require("./devices/multisensorPCB"));
var multiwhite_1 = __importDefault(require("./devices/multiwhite"));
var nanopi_1 = __importDefault(require("./devices/nanopi"));
var nimbusModulQ_1 = __importDefault(require("./devices/nimbusModulQ"));
var nimbusRoxxane_1 = __importDefault(require("./devices/nimbusRoxxane"));
var nimbusWinglet_1 = __importDefault(require("./devices/nimbusWinglet"));
var nuimo_1 = __importDefault(require("./devices/nuimo"));
var OPCUA_1 = __importDefault(require("./devices/OPCUA"));
var oven_1 = __importDefault(require("./devices/oven"));
var printer3d_1 = __importDefault(require("./devices/printer3d"));
var radiator_1 = __importDefault(require("./devices/radiator"));
var remote_1 = __importDefault(require("./devices/remote"));
var remoteDirection_1 = __importDefault(require("./devices/remoteDirection"));
var remoteEco_1 = __importDefault(require("./devices/remoteEco"));
var remoteMovement_1 = __importDefault(require("./devices/remoteMovement"));
var rgb_1 = __importDefault(require("./devices/rgb"));
var robot_1 = __importDefault(require("./devices/robot"));
var robotVacuumCleaner_1 = __importDefault(require("./devices/robotVacuumCleaner"));
var ROS_1 = __importDefault(require("./devices/ROS"));
var scanner_1 = __importDefault(require("./devices/scanner"));
var slider_1 = __importDefault(require("./devices/slider"));
var slidingDoorLeft_1 = __importDefault(require("./devices/slidingDoorLeft"));
var slidingDoorRight_1 = __importDefault(require("./devices/slidingDoorRight"));
var smartphone_1 = __importDefault(require("./devices/smartphone"));
var smartwatch_1 = __importDefault(require("./devices/smartwatch"));
var socket_1 = __importDefault(require("./devices/socket"));
var speaker_1 = __importDefault(require("./devices/speaker"));
var spot_1 = __importDefault(require("./devices/spot"));
var spot2_1 = __importDefault(require("./devices/spot2"));
var steamer_1 = __importDefault(require("./devices/steamer"));
var stove_1 = __importDefault(require("./devices/stove"));
var streamdeck_1 = __importDefault(require("./devices/streamdeck"));
var switch_1 = __importDefault(require("./devices/switch"));
var switchDouble_1 = __importDefault(require("./devices/switchDouble"));
var switchDoubleLeft_1 = __importDefault(require("./devices/switchDoubleLeft"));
var switchDoubleRight_1 = __importDefault(require("./devices/switchDoubleRight"));
var switchTouch_1 = __importDefault(require("./devices/switchTouch"));
var tablet_1 = __importDefault(require("./devices/tablet"));
var tcp_1 = __importDefault(require("./devices/tcp"));
var thingosHub_1 = __importDefault(require("./devices/thingosHub"));
var toaster_1 = __importDefault(require("./devices/toaster"));
var toothbrush_1 = __importDefault(require("./devices/toothbrush"));
var tss_1 = __importDefault(require("./devices/tss"));
var tumbleDryer_1 = __importDefault(require("./devices/tumbleDryer"));
var tvHide_1 = __importDefault(require("./devices/tvHide"));
var tvLiftBackward_1 = __importDefault(require("./devices/tvLiftBackward"));
var tvLiftDown_1 = __importDefault(require("./devices/tvLiftDown"));
var tvLiftForward_1 = __importDefault(require("./devices/tvLiftForward"));
var tvLiftUp_1 = __importDefault(require("./devices/tvLiftUp"));
var tvReveal_1 = __importDefault(require("./devices/tvReveal"));
var UDP_1 = __importDefault(require("./devices/UDP"));
var usb_1 = __importDefault(require("./devices/usb"));
var wallcontrollerPCB_1 = __importDefault(require("./devices/wallcontrollerPCB"));
var wallSwitchHaefele_1 = __importDefault(require("./devices/wallSwitchHaefele"));
var wallSwitchHaefele1_1 = __importDefault(require("./devices/wallSwitchHaefele1"));
var wallSwitchHaefele2_1 = __importDefault(require("./devices/wallSwitchHaefele2"));
var wallSwitchHaefele3_1 = __importDefault(require("./devices/wallSwitchHaefele3"));
var wallSwitchHaefele4_1 = __importDefault(require("./devices/wallSwitchHaefele4"));
var wallSwitchHaefeleUS_1 = __importDefault(require("./devices/wallSwitchHaefeleUS"));
var wallSwitchHaefeleUS1_1 = __importDefault(require("./devices/wallSwitchHaefeleUS1"));
var wallSwitchHaefeleUS2_1 = __importDefault(require("./devices/wallSwitchHaefeleUS2"));
var wallSwitchHaefeleUS3_1 = __importDefault(require("./devices/wallSwitchHaefeleUS3"));
var wallSwitchHaefeleUS4_1 = __importDefault(require("./devices/wallSwitchHaefeleUS4"));
var wardrobeLift_1 = __importDefault(require("./devices/wardrobeLift"));
var washingMachine_1 = __importDefault(require("./devices/washingMachine"));
var webcam_1 = __importDefault(require("./devices/webcam"));
var windowSensor_1 = __importDefault(require("./devices/windowSensor"));
var accelerometer_1 = __importDefault(require("./modules/accelerometer"));
var analogIn_1 = __importDefault(require("./modules/analogIn"));
var analogOut_1 = __importDefault(require("./modules/analogOut"));
var ar_1 = __importDefault(require("./modules/ar"));
var audio_1 = __importDefault(require("./modules/audio"));
var barcodeScanner_1 = __importDefault(require("./modules/barcodeScanner"));
var battery_1 = __importDefault(require("./modules/battery"));
var bluetooth_1 = __importDefault(require("./modules/bluetooth"));
var brightness_1 = __importDefault(require("./modules/brightness"));
var button_1 = __importDefault(require("./modules/button"));
var circledIO_1 = __importDefault(require("./modules/circledIO"));
var color_1 = __importDefault(require("./modules/color"));
var communicationProtocol_1 = __importDefault(require("./modules/communicationProtocol"));
var contrast_1 = __importDefault(require("./modules/contrast"));
var deskDown_1 = __importDefault(require("./modules/deskDown"));
var deskUp_1 = __importDefault(require("./modules/deskUp"));
var digitalIn_1 = __importDefault(require("./modules/digitalIn"));
var digitalOut_1 = __importDefault(require("./modules/digitalOut"));
var dust_1 = __importDefault(require("./modules/dust"));
var electricity_1 = __importDefault(require("./modules/electricity"));
var fingerprint_1 = __importDefault(require("./modules/fingerprint"));
var genericIn_1 = __importDefault(require("./modules/genericIn"));
var genericOut_1 = __importDefault(require("./modules/genericOut"));
var group_1 = __importDefault(require("./modules/group"));
var gyroscope_1 = __importDefault(require("./modules/gyroscope"));
var heartrate_1 = __importDefault(require("./modules/heartrate"));
var humidity_1 = __importDefault(require("./modules/humidity"));
var joystick_1 = __importDefault(require("./modules/joystick"));
var location_1 = __importDefault(require("./modules/location"));
var magnet_1 = __importDefault(require("./modules/magnet"));
var magneticField_1 = __importDefault(require("./modules/magneticField"));
var motion_1 = __importDefault(require("./modules/motion"));
var nfc_1 = __importDefault(require("./modules/nfc"));
var notification_1 = __importDefault(require("./modules/notification"));
var pressure_1 = __importDefault(require("./modules/pressure"));
var proximity_1 = __importDefault(require("./modules/proximity"));
var pwm_1 = __importDefault(require("./modules/pwm"));
var qr_1 = __importDefault(require("./modules/qr"));
var rotation_1 = __importDefault(require("./modules/rotation"));
var signalRecieve_1 = __importDefault(require("./modules/signalRecieve"));
var signalSend_1 = __importDefault(require("./modules/signalSend"));
var smoke_1 = __importDefault(require("./modules/smoke"));
var speech_1 = __importDefault(require("./modules/speech"));
var squaredIO_1 = __importDefault(require("./modules/squaredIO"));
var switchPressed_1 = __importDefault(require("./modules/switchPressed"));
var switchReleased_1 = __importDefault(require("./modules/switchReleased"));
var tcpRead_1 = __importDefault(require("./modules/tcpRead"));
var tcpWrite_1 = __importDefault(require("./modules/tcpWrite"));
var temperature_1 = __importDefault(require("./modules/temperature"));
var time_1 = __importDefault(require("./modules/time"));
var touch_1 = __importDefault(require("./modules/touch"));
var usb_2 = __importDefault(require("./modules/usb"));
var usbIn_1 = __importDefault(require("./modules/usbIn"));
var usbOut_1 = __importDefault(require("./modules/usbOut"));
var webdisplay_1 = __importDefault(require("./modules/webdisplay"));
var bathroom_1 = __importDefault(require("./rooms/bathroom"));
var bedroom_1 = __importDefault(require("./rooms/bedroom"));
var defaultroom_1 = __importDefault(require("./rooms/defaultroom"));
var deskroom_1 = __importDefault(require("./rooms/deskroom"));
var diningroom_1 = __importDefault(require("./rooms/diningroom"));
var dressingroom_1 = __importDefault(require("./rooms/dressingroom"));
var fitnessroom_1 = __importDefault(require("./rooms/fitnessroom"));
var garage_1 = __importDefault(require("./rooms/garage"));
var gazebo_1 = __importDefault(require("./rooms/gazebo"));
var kitchen_1 = __importDefault(require("./rooms/kitchen"));
var laundryroom_1 = __importDefault(require("./rooms/laundryroom"));
var livingroom_1 = __importDefault(require("./rooms/livingroom"));
var nursery_1 = __importDefault(require("./rooms/nursery"));
var toilet_1 = __importDefault(require("./rooms/toilet"));
var warehouse_1 = __importDefault(require("./rooms/warehouse"));
var alexa_1 = __importDefault(require("./services/alexa"));
var amazon_1 = __importDefault(require("./services/amazon"));
var bosch_1 = __importDefault(require("./services/bosch"));
var docker_1 = __importDefault(require("./services/docker"));
var facebook_1 = __importDefault(require("./services/facebook"));
var haefele_1 = __importDefault(require("./services/haefele"));
var hubApp_1 = __importDefault(require("./services/hubApp"));
var influxdata_1 = __importDefault(require("./services/influxdata"));
var linkedIn_1 = __importDefault(require("./services/linkedIn"));
var meshApp_1 = __importDefault(require("./services/meshApp"));
var naise_1 = __importDefault(require("./services/naise"));
var slack_1 = __importDefault(require("./services/slack"));
var thingos_1 = __importDefault(require("./services/thingos"));
var twitter_1 = __importDefault(require("./services/twitter"));
var windows_1 = __importDefault(require("./services/windows"));
var youtube_1 = __importDefault(require("./services/youtube"));
var _1Square_1 = __importDefault(require("./ui/1Square"));
var _2Square_1 = __importDefault(require("./ui/2Square"));
var _3Seconds_1 = __importDefault(require("./ui/3Seconds"));
var _3Square_1 = __importDefault(require("./ui/3Square"));
var _4Seconds_1 = __importDefault(require("./ui/4Seconds"));
var _4Square_1 = __importDefault(require("./ui/4Square"));
var _5Square_1 = __importDefault(require("./ui/5Square"));
var _6Square_1 = __importDefault(require("./ui/6Square"));
var _7Square_1 = __importDefault(require("./ui/7Square"));
var _8Square_1 = __importDefault(require("./ui/8Square"));
var accuracy_1 = __importDefault(require("./ui/accuracy"));
var add_1 = __importDefault(require("./ui/add"));
var alert_1 = __importDefault(require("./ui/alert"));
var allDevices_1 = __importDefault(require("./ui/allDevices"));
var analyticsWeb_1 = __importDefault(require("./ui/analyticsWeb"));
var and_1 = __importDefault(require("./ui/and"));
var andSquare_1 = __importDefault(require("./ui/andSquare"));
var angle_1 = __importDefault(require("./ui/angle"));
var answers_1 = __importDefault(require("./ui/answers"));
var app_1 = __importDefault(require("./ui/app"));
var arrowDown_1 = __importDefault(require("./ui/arrowDown"));
var arrowLeft_1 = __importDefault(require("./ui/arrowLeft"));
var arrowRight_1 = __importDefault(require("./ui/arrowRight"));
var arrowUp_1 = __importDefault(require("./ui/arrowUp"));
var article_1 = __importDefault(require("./ui/article"));
var ASquare_1 = __importDefault(require("./ui/ASquare"));
var autoScrollSequence_1 = __importDefault(require("./ui/autoScrollSequence"));
var backup_1 = __importDefault(require("./ui/backup"));
var batteryEmpty_1 = __importDefault(require("./ui/batteryEmpty"));
var batteryFull_1 = __importDefault(require("./ui/batteryFull"));
var batteryMedium_1 = __importDefault(require("./ui/batteryMedium"));
var batteryStrong_1 = __importDefault(require("./ui/batteryStrong"));
var batteryUpdate_1 = __importDefault(require("./ui/batteryUpdate"));
var batteryWeak_1 = __importDefault(require("./ui/batteryWeak"));
var bin_1 = __importDefault(require("./ui/bin"));
var book_1 = __importDefault(require("./ui/book"));
var bookmark_1 = __importDefault(require("./ui/bookmark"));
var brightnessMinus_1 = __importDefault(require("./ui/brightnessMinus"));
var brightnessPlus_1 = __importDefault(require("./ui/brightnessPlus"));
var broadcast_1 = __importDefault(require("./ui/broadcast"));
var brush_1 = __importDefault(require("./ui/brush"));
var BSquare_1 = __importDefault(require("./ui/BSquare"));
var camera_1 = __importDefault(require("./ui/camera"));
var cancel_1 = __importDefault(require("./ui/cancel"));
var cart_1 = __importDefault(require("./ui/cart"));
var circle_1 = __importDefault(require("./ui/circle"));
var circledBackward_1 = __importDefault(require("./ui/circledBackward"));
var circledDone_1 = __importDefault(require("./ui/circledDone"));
var circledForeward_1 = __importDefault(require("./ui/circledForeward"));
var circledMinus_1 = __importDefault(require("./ui/circledMinus"));
var circledPause_1 = __importDefault(require("./ui/circledPause"));
var circledPlay_1 = __importDefault(require("./ui/circledPlay"));
var circledStop_1 = __importDefault(require("./ui/circledStop"));
var cloudDone_1 = __importDefault(require("./ui/cloudDone"));
var cloudDownload_1 = __importDefault(require("./ui/cloudDownload"));
var cloudError_1 = __importDefault(require("./ui/cloudError"));
var cloudUpload_1 = __importDefault(require("./ui/cloudUpload"));
var colorLeft_1 = __importDefault(require("./ui/colorLeft"));
var colorRight_1 = __importDefault(require("./ui/colorRight"));
var compress_1 = __importDefault(require("./ui/compress"));
var configuration_1 = __importDefault(require("./ui/configuration"));
var configurationSquare_1 = __importDefault(require("./ui/configurationSquare"));
var configurationTriangle_1 = __importDefault(require("./ui/configurationTriangle"));
var connected_1 = __importDefault(require("./ui/connected"));
var connectionEmpty_1 = __importDefault(require("./ui/connectionEmpty"));
var connectionError_1 = __importDefault(require("./ui/connectionError"));
var connectionMedium_1 = __importDefault(require("./ui/connectionMedium"));
var connectionStrong_1 = __importDefault(require("./ui/connectionStrong"));
var connectionWeak_1 = __importDefault(require("./ui/connectionWeak"));
var connectionWifiEmpty_1 = __importDefault(require("./ui/connectionWifiEmpty"));
var connectionWifiMedium_1 = __importDefault(require("./ui/connectionWifiMedium"));
var connectionWifiStrong_1 = __importDefault(require("./ui/connectionWifiStrong"));
var connectionWifiWeak_1 = __importDefault(require("./ui/connectionWifiWeak"));
var copy_1 = __importDefault(require("./ui/copy"));
var CSquare_1 = __importDefault(require("./ui/CSquare"));
var cubeOrthogonal_1 = __importDefault(require("./ui/cubeOrthogonal"));
var darkmode_1 = __importDefault(require("./ui/darkmode"));
var delete_1 = __importDefault(require("./ui/delete"));
var details_1 = __importDefault(require("./ui/details"));
var diamond_1 = __importDefault(require("./ui/diamond"));
var disconnected_1 = __importDefault(require("./ui/disconnected"));
var distance_1 = __importDefault(require("./ui/distance"));
var doctorsBag_1 = __importDefault(require("./ui/doctorsBag"));
var document_1 = __importDefault(require("./ui/document"));
var documentImage_1 = __importDefault(require("./ui/documentImage"));
var documents_1 = __importDefault(require("./ui/documents"));
var done_1 = __importDefault(require("./ui/done"));
var edit_1 = __importDefault(require("./ui/edit"));
var equal_1 = __importDefault(require("./ui/equal"));
var equalSquare_1 = __importDefault(require("./ui/equalSquare"));
var error_1 = __importDefault(require("./ui/error"));
var event_1 = __importDefault(require("./ui/event"));
var exchange_1 = __importDefault(require("./ui/exchange"));
var execute_1 = __importDefault(require("./ui/execute"));
var expand_1 = __importDefault(require("./ui/expand"));
var export_1 = __importDefault(require("./ui/export"));
var exportSequence_1 = __importDefault(require("./ui/exportSequence"));
var eye_1 = __importDefault(require("./ui/eye"));
var favorite_1 = __importDefault(require("./ui/favorite"));
var filter_1 = __importDefault(require("./ui/filter"));
var finish_1 = __importDefault(require("./ui/finish"));
var flashOff_1 = __importDefault(require("./ui/flashOff"));
var flashOn_1 = __importDefault(require("./ui/flashOn"));
var folder_1 = __importDefault(require("./ui/folder"));
var folderAdd_1 = __importDefault(require("./ui/folderAdd"));
var folderMove_1 = __importDefault(require("./ui/folderMove"));
var foodTruck_1 = __importDefault(require("./ui/foodTruck"));
var grid_1 = __importDefault(require("./ui/grid"));
var grove_1 = __importDefault(require("./ui/grove"));
var help_1 = __importDefault(require("./ui/help"));
var hide_1 = __importDefault(require("./ui/hide"));
var highPrice_1 = __importDefault(require("./ui/highPrice"));
var home_1 = __importDefault(require("./ui/home"));
var hsb_1 = __importDefault(require("./ui/hsb"));
var idea_1 = __importDefault(require("./ui/idea"));
var import_1 = __importDefault(require("./ui/import"));
var importSequence_1 = __importDefault(require("./ui/importSequence"));
var information_1 = __importDefault(require("./ui/information"));
var informationOff_1 = __importDefault(require("./ui/informationOff"));
var jumpTo_1 = __importDefault(require("./ui/jumpTo"));
var less_1 = __importDefault(require("./ui/less"));
var lessEqual_1 = __importDefault(require("./ui/lessEqual"));
var lessEqualSquare_1 = __importDefault(require("./ui/lessEqualSquare"));
var lessSquare_1 = __importDefault(require("./ui/lessSquare"));
var levels_1 = __importDefault(require("./ui/levels"));
var lightmode_1 = __importDefault(require("./ui/lightmode"));
var linechart_1 = __importDefault(require("./ui/linechart"));
var list_1 = __importDefault(require("./ui/list"));
var live_1 = __importDefault(require("./ui/live"));
var login_1 = __importDefault(require("./ui/login"));
var logout_1 = __importDefault(require("./ui/logout"));
var lowPrice_1 = __importDefault(require("./ui/lowPrice"));
var magic_1 = __importDefault(require("./ui/magic"));
var max_1 = __importDefault(require("./ui/max"));
var menuBurger_1 = __importDefault(require("./ui/menuBurger"));
var menuDots_1 = __importDefault(require("./ui/menuDots"));
var min_1 = __importDefault(require("./ui/min"));
var mirrorValue_1 = __importDefault(require("./ui/mirrorValue"));
var moon_1 = __importDefault(require("./ui/moon"));
var more_1 = __importDefault(require("./ui/more"));
var moreEqual_1 = __importDefault(require("./ui/moreEqual"));
var moreEqualSquare_1 = __importDefault(require("./ui/moreEqualSquare"));
var moreSquare_1 = __importDefault(require("./ui/moreSquare"));
var networkDecentral_1 = __importDefault(require("./ui/networkDecentral"));
var networkDecentralSetup_1 = __importDefault(require("./ui/networkDecentralSetup"));
var networkHub_1 = __importDefault(require("./ui/networkHub"));
var new_1 = __importDefault(require("./ui/new"));
var noHub_1 = __importDefault(require("./ui/noHub"));
var notEqual_1 = __importDefault(require("./ui/notEqual"));
var notEqualSquare_1 = __importDefault(require("./ui/notEqualSquare"));
var off_1 = __importDefault(require("./ui/off"));
var on_1 = __importDefault(require("./ui/on"));
var openStandard_1 = __importDefault(require("./ui/openStandard"));
var or_1 = __importDefault(require("./ui/or"));
var orSquare_1 = __importDefault(require("./ui/orSquare"));
var palette_1 = __importDefault(require("./ui/palette"));
var paste_1 = __importDefault(require("./ui/paste"));
var pasteText_1 = __importDefault(require("./ui/pasteText"));
var pause_1 = __importDefault(require("./ui/pause"));
var person_1 = __importDefault(require("./ui/person"));
var pin_1 = __importDefault(require("./ui/pin"));
var play_1 = __importDefault(require("./ui/play"));
var plugins_1 = __importDefault(require("./ui/plugins"));
var puzzle_1 = __importDefault(require("./ui/puzzle"));
var questions_1 = __importDefault(require("./ui/questions"));
var rain_1 = __importDefault(require("./ui/rain"));
var redo_1 = __importDefault(require("./ui/redo"));
var reference_1 = __importDefault(require("./ui/reference"));
var refresh_1 = __importDefault(require("./ui/refresh"));
var removeNetworkDecentral_1 = __importDefault(require("./ui/removeNetworkDecentral"));
var removePerson_1 = __importDefault(require("./ui/removePerson"));
var removeShop_1 = __importDefault(require("./ui/removeShop"));
var reorder_1 = __importDefault(require("./ui/reorder"));
var reset_1 = __importDefault(require("./ui/reset"));
var resolution_1 = __importDefault(require("./ui/resolution"));
var restart_1 = __importDefault(require("./ui/restart"));
var rgb_2 = __importDefault(require("./ui/rgb"));
var row_1 = __importDefault(require("./ui/row"));
var rule_1 = __importDefault(require("./ui/rule"));
var running_1 = __importDefault(require("./ui/running"));
var saturationMinus_1 = __importDefault(require("./ui/saturationMinus"));
var saturationPlus_1 = __importDefault(require("./ui/saturationPlus"));
var save_1 = __importDefault(require("./ui/save"));
var saveNext_1 = __importDefault(require("./ui/saveNext"));
var scene_1 = __importDefault(require("./ui/scene"));
var search_1 = __importDefault(require("./ui/search"));
var searchList_1 = __importDefault(require("./ui/searchList"));
var searchSquare_1 = __importDefault(require("./ui/searchSquare"));
var securityChecked_1 = __importDefault(require("./ui/securityChecked"));
var sensor_1 = __importDefault(require("./ui/sensor"));
var settings_1 = __importDefault(require("./ui/settings"));
var share_1 = __importDefault(require("./ui/share"));
var shareIOS_1 = __importDefault(require("./ui/shareIOS"));
var shop_1 = __importDefault(require("./ui/shop"));
var shutdown_1 = __importDefault(require("./ui/shutdown"));
var smarthome_1 = __importDefault(require("./ui/smarthome"));
var snow_1 = __importDefault(require("./ui/snow"));
var sortAlphabetically_1 = __importDefault(require("./ui/sortAlphabetically"));
var sortByDevice_1 = __importDefault(require("./ui/sortByDevice"));
var sortByDeviceIndustrial_1 = __importDefault(require("./ui/sortByDeviceIndustrial"));
var speechBubble_1 = __importDefault(require("./ui/speechBubble"));
var speed_1 = __importDefault(require("./ui/speed"));
var starEdit_1 = __importDefault(require("./ui/starEdit"));
var starEmpty_1 = __importDefault(require("./ui/starEmpty"));
var starFull_1 = __importDefault(require("./ui/starFull"));
var starHalf_1 = __importDefault(require("./ui/starHalf"));
var statistics_1 = __importDefault(require("./ui/statistics"));
var stethoscope_1 = __importDefault(require("./ui/stethoscope"));
var structure_1 = __importDefault(require("./ui/structure"));
var suitcase_1 = __importDefault(require("./ui/suitcase"));
var sun_1 = __importDefault(require("./ui/sun"));
var sunriseHouse_1 = __importDefault(require("./ui/sunriseHouse"));
var sunset_1 = __importDefault(require("./ui/sunset"));
var temperatureMinus_1 = __importDefault(require("./ui/temperatureMinus"));
var temperaturePlus_1 = __importDefault(require("./ui/temperaturePlus"));
var time_2 = __importDefault(require("./ui/time"));
var timeBackward_1 = __importDefault(require("./ui/timeBackward"));
var timeForward_1 = __importDefault(require("./ui/timeForward"));
var toggle_1 = __importDefault(require("./ui/toggle"));
var tool_1 = __importDefault(require("./ui/tool"));
var training_1 = __importDefault(require("./ui/training"));
var translate_1 = __importDefault(require("./ui/translate"));
var umbrella_1 = __importDefault(require("./ui/umbrella"));
var undo_1 = __importDefault(require("./ui/undo"));
var update_1 = __importDefault(require("./ui/update"));
var virtual_1 = __importDefault(require("./ui/virtual"));
var windowConsole_1 = __importDefault(require("./ui/windowConsole"));
var windowList_1 = __importDefault(require("./ui/windowList"));
var windowSettings_1 = __importDefault(require("./ui/windowSettings"));
var workflow_1 = __importDefault(require("./ui/workflow"));
var world_1 = __importDefault(require("./ui/world"));
var iconList = [
    'devices/agv',
    'devices/agvSmall',
    'devices/android',
    'devices/apple',
    'devices/arduino',
    'devices/blebox4',
    'devices/blebox6',
    'devices/bleRemote',
    'devices/bleRemote2',
    'devices/bulb_hue',
    'devices/bulb_lifx',
    'devices/bulb',
    'devices/coffeeMachine',
    'devices/conveyorBelt',
    'devices/desk',
    'devices/devBoard',
    'devices/dimmer',
    'devices/dimmerOld',
    'devices/dishwasher',
    'devices/doorSensor',
    'devices/drone',
    'devices/echo',
    'devices/echoDot',
    'devices/esp',
    'devices/fan',
    'devices/firmata',
    'devices/fridge',
    'devices/genericDimmer',
    'devices/genericSwitch',
    'devices/googleHomeMini',
    'devices/haefeleHub',
    'devices/hueBridge',
    'devices/hueDimmerRemote',
    'devices/hueLightSwitch',
    'devices/ioLink',
    'devices/kettle',
    'devices/KNX',
    'devices/lampDesk',
    'devices/lampStand',
    'devices/lampTable',
    'devices/lampTable2',
    'devices/lampWall',
    'devices/ledband',
    'devices/lightingPadRound',
    'devices/lightingPadRoundDirect',
    'devices/lightingPadRoundIndirect',
    'devices/lightingPadSquare',
    'devices/lightingPadSquareDirect',
    'devices/lightingPadSquareIndirect',
    'devices/lock',
    'devices/lockOpen',
    'devices/lockTime',
    'devices/meshbox2wire',
    'devices/meshboxEco',
    'devices/meshboxEco1MW',
    'devices/meshboxEcoMW',
    'devices/meshboxEcoRGB',
    'devices/meshThing',
    'devices/meshthingNotification',
    'devices/microsoft',
    'devices/microwave',
    'devices/mixer',
    'devices/motionSensor',
    'devices/motorElectric',
    'devices/movementSensor',
    'devices/MQTT',
    'devices/multisensorPCB',
    'devices/multiwhite',
    'devices/nanopi',
    'devices/nimbusModulQ',
    'devices/nimbusRoxxane',
    'devices/nimbusWinglet',
    'devices/nuimo',
    'devices/OPCUA',
    'devices/oven',
    'devices/printer3d',
    'devices/radiator',
    'devices/remote',
    'devices/remoteDirection',
    'devices/remoteEco',
    'devices/remoteMovement',
    'devices/rgb',
    'devices/robot',
    'devices/robotVacuumCleaner',
    'devices/ROS',
    'devices/scanner',
    'devices/slider',
    'devices/slidingDoorLeft',
    'devices/slidingDoorRight',
    'devices/smartphone',
    'devices/smartwatch',
    'devices/socket',
    'devices/speaker',
    'devices/spot',
    'devices/spot2',
    'devices/steamer',
    'devices/stove',
    'devices/streamdeck',
    'devices/switch',
    'devices/switchDouble',
    'devices/switchDoubleLeft',
    'devices/switchDoubleRight',
    'devices/switchTouch',
    'devices/tablet',
    'devices/tcp',
    'devices/thingosHub',
    'devices/toaster',
    'devices/toothbrush',
    'devices/tss',
    'devices/tumbleDryer',
    'devices/tvHide',
    'devices/tvLiftBackward',
    'devices/tvLiftDown',
    'devices/tvLiftForward',
    'devices/tvLiftUp',
    'devices/tvReveal',
    'devices/UDP',
    'devices/usb',
    'devices/wallcontrollerPCB',
    'devices/wallSwitchHaefele',
    'devices/wallSwitchHaefele1',
    'devices/wallSwitchHaefele2',
    'devices/wallSwitchHaefele3',
    'devices/wallSwitchHaefele4',
    'devices/wallSwitchHaefeleUS',
    'devices/wallSwitchHaefeleUS1',
    'devices/wallSwitchHaefeleUS2',
    'devices/wallSwitchHaefeleUS3',
    'devices/wallSwitchHaefeleUS4',
    'devices/wardrobeLift',
    'devices/washingMachine',
    'devices/webcam',
    'devices/windowSensor',
    'modules/accelerometer',
    'modules/analogIn',
    'modules/analogOut',
    'modules/ar',
    'modules/audio',
    'modules/barcodeScanner',
    'modules/battery',
    'modules/bluetooth',
    'modules/brightness',
    'modules/button',
    'modules/circledIO',
    'modules/color',
    'modules/communicationProtocol',
    'modules/contrast',
    'modules/deskDown',
    'modules/deskUp',
    'modules/digitalIn',
    'modules/digitalOut',
    'modules/dust',
    'modules/electricity',
    'modules/fingerprint',
    'modules/genericIn',
    'modules/genericOut',
    'modules/group',
    'modules/gyroscope',
    'modules/heartrate',
    'modules/humidity',
    'modules/joystick',
    'modules/location',
    'modules/magnet',
    'modules/magneticField',
    'modules/motion',
    'modules/nfc',
    'modules/notification',
    'modules/pressure',
    'modules/proximity',
    'modules/pwm',
    'modules/qr',
    'modules/rotation',
    'modules/signalRecieve',
    'modules/signalSend',
    'modules/smoke',
    'modules/speech',
    'modules/squaredIO',
    'modules/switchPressed',
    'modules/switchReleased',
    'modules/tcpRead',
    'modules/tcpWrite',
    'modules/temperature',
    'modules/time',
    'modules/touch',
    'modules/usb',
    'modules/usbIn',
    'modules/usbOut',
    'modules/webdisplay',
    'rooms/bathroom',
    'rooms/bedroom',
    'rooms/defaultroom',
    'rooms/deskroom',
    'rooms/diningroom',
    'rooms/dressingroom',
    'rooms/fitnessroom',
    'rooms/garage',
    'rooms/gazebo',
    'rooms/kitchen',
    'rooms/laundryroom',
    'rooms/livingroom',
    'rooms/nursery',
    'rooms/toilet',
    'rooms/warehouse',
    'services/alexa',
    'services/amazon',
    'services/bosch',
    'services/docker',
    'services/facebook',
    'services/haefele',
    'services/hubApp',
    'services/influxdata',
    'services/linkedIn',
    'services/meshApp',
    'services/naise',
    'services/slack',
    'services/thingos',
    'services/twitter',
    'services/windows',
    'services/youtube',
    'ui/1Square',
    'ui/2Square',
    'ui/3Seconds',
    'ui/3Square',
    'ui/4Seconds',
    'ui/4Square',
    'ui/5Square',
    'ui/6Square',
    'ui/7Square',
    'ui/8Square',
    'ui/accuracy',
    'ui/add',
    'ui/alert',
    'ui/allDevices',
    'ui/analyticsWeb',
    'ui/and',
    'ui/andSquare',
    'ui/angle',
    'ui/answers',
    'ui/app',
    'ui/arrowDown',
    'ui/arrowLeft',
    'ui/arrowRight',
    'ui/arrowUp',
    'ui/article',
    'ui/ASquare',
    'ui/autoScrollSequence',
    'ui/backup',
    'ui/batteryEmpty',
    'ui/batteryFull',
    'ui/batteryMedium',
    'ui/batteryStrong',
    'ui/batteryUpdate',
    'ui/batteryWeak',
    'ui/bin',
    'ui/book',
    'ui/bookmark',
    'ui/brightnessMinus',
    'ui/brightnessPlus',
    'ui/broadcast',
    'ui/brush',
    'ui/BSquare',
    'ui/camera',
    'ui/cancel',
    'ui/cart',
    'ui/circle',
    'ui/circledBackward',
    'ui/circledDone',
    'ui/circledForeward',
    'ui/circledMinus',
    'ui/circledPause',
    'ui/circledPlay',
    'ui/circledStop',
    'ui/cloudDone',
    'ui/cloudDownload',
    'ui/cloudError',
    'ui/cloudUpload',
    'ui/colorLeft',
    'ui/colorRight',
    'ui/compress',
    'ui/configuration',
    'ui/configurationSquare',
    'ui/configurationTriangle',
    'ui/connected',
    'ui/connectionEmpty',
    'ui/connectionError',
    'ui/connectionMedium',
    'ui/connectionStrong',
    'ui/connectionWeak',
    'ui/connectionWifiEmpty',
    'ui/connectionWifiMedium',
    'ui/connectionWifiStrong',
    'ui/connectionWifiWeak',
    'ui/copy',
    'ui/CSquare',
    'ui/cubeOrthogonal',
    'ui/darkmode',
    'ui/delete',
    'ui/details',
    'ui/diamond',
    'ui/disconnected',
    'ui/distance',
    'ui/doctorsBag',
    'ui/document',
    'ui/documentImage',
    'ui/documents',
    'ui/done',
    'ui/edit',
    'ui/equal',
    'ui/equalSquare',
    'ui/error',
    'ui/event',
    'ui/exchange',
    'ui/execute',
    'ui/expand',
    'ui/export',
    'ui/exportSequence',
    'ui/eye',
    'ui/favorite',
    'ui/filter',
    'ui/finish',
    'ui/flashOff',
    'ui/flashOn',
    'ui/folder',
    'ui/folderAdd',
    'ui/folderMove',
    'ui/foodTruck',
    'ui/grid',
    'ui/grove',
    'ui/help',
    'ui/hide',
    'ui/highPrice',
    'ui/home',
    'ui/hsb',
    'ui/idea',
    'ui/import',
    'ui/importSequence',
    'ui/information',
    'ui/informationOff',
    'ui/jumpTo',
    'ui/less',
    'ui/lessEqual',
    'ui/lessEqualSquare',
    'ui/lessSquare',
    'ui/levels',
    'ui/lightmode',
    'ui/linechart',
    'ui/list',
    'ui/live',
    'ui/login',
    'ui/logout',
    'ui/lowPrice',
    'ui/magic',
    'ui/max',
    'ui/menuBurger',
    'ui/menuDots',
    'ui/min',
    'ui/mirrorValue',
    'ui/moon',
    'ui/more',
    'ui/moreEqual',
    'ui/moreEqualSquare',
    'ui/moreSquare',
    'ui/networkDecentral',
    'ui/networkDecentralSetup',
    'ui/networkHub',
    'ui/new',
    'ui/noHub',
    'ui/notEqual',
    'ui/notEqualSquare',
    'ui/off',
    'ui/on',
    'ui/openStandard',
    'ui/or',
    'ui/orSquare',
    'ui/palette',
    'ui/paste',
    'ui/pasteText',
    'ui/pause',
    'ui/person',
    'ui/pin',
    'ui/play',
    'ui/plugins',
    'ui/puzzle',
    'ui/questions',
    'ui/rain',
    'ui/redo',
    'ui/reference',
    'ui/refresh',
    'ui/removeNetworkDecentral',
    'ui/removePerson',
    'ui/removeShop',
    'ui/reorder',
    'ui/reset',
    'ui/resolution',
    'ui/restart',
    'ui/rgb',
    'ui/row',
    'ui/rule',
    'ui/running',
    'ui/saturationMinus',
    'ui/saturationPlus',
    'ui/save',
    'ui/saveNext',
    'ui/scene',
    'ui/search',
    'ui/searchList',
    'ui/searchSquare',
    'ui/securityChecked',
    'ui/sensor',
    'ui/settings',
    'ui/share',
    'ui/shareIOS',
    'ui/shop',
    'ui/shutdown',
    'ui/smarthome',
    'ui/snow',
    'ui/sortAlphabetically',
    'ui/sortByDevice',
    'ui/sortByDeviceIndustrial',
    'ui/speechBubble',
    'ui/speed',
    'ui/starEdit',
    'ui/starEmpty',
    'ui/starFull',
    'ui/starHalf',
    'ui/statistics',
    'ui/stethoscope',
    'ui/structure',
    'ui/suitcase',
    'ui/sun',
    'ui/sunriseHouse',
    'ui/sunset',
    'ui/temperatureMinus',
    'ui/temperaturePlus',
    'ui/time',
    'ui/timeBackward',
    'ui/timeForward',
    'ui/toggle',
    'ui/tool',
    'ui/training',
    'ui/translate',
    'ui/umbrella',
    'ui/undo',
    'ui/update',
    'ui/virtual',
    'ui/windowConsole',
    'ui/windowList',
    'ui/windowSettings',
    'ui/workflow',
    'ui/world',
];
var Icon = /** @class */ (function (_super) {
    __extends(Icon, _super);
    function Icon() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Icon.prototype.render = function () {
        var _a = this.props, kind = _a.kind, preview = _a.preview, previewIconStyle = _a.previewIconStyle;
        return preview ? this.renderPreview(previewIconStyle) : this.renderIcon(kind);
    };
    Icon.prototype.renderPreview = function (previewIconStyle) {
        var _this = this;
        return (React.createElement("div", { className: "preview-container" }, iconList.map(function (kind) { return _this.renderPreviewKind(kind, previewIconStyle); })));
    };
    Icon.prototype.renderIcon = function (kind) {
        var wrapperStyle = this.props.wrapperStyle;
        if (wrapperStyle) {
            return (React.createElement("div", { style: wrapperStyle }, this.getIcon(kind)));
        }
        return this.getIcon(kind);
    };
    Icon.prototype.renderPreviewKind = function (kind, previewIconStyle) {
        return (React.createElement("div", { className: "preview-icon", key: kind, style: previewIconStyle },
            React.createElement("h3", null,
                "<Icon kind=\"",
                kind,
                "\" />"),
            this.renderIcon(kind)));
    };
    Icon.prototype.getIcon = function (kind) {
        switch (kind) {
            case ('devices/agv'): return (React.createElement(agv_1.default, __assign({}, this.props)));
            case ('devices/agvSmall'): return (React.createElement(agvSmall_1.default, __assign({}, this.props)));
            case ('devices/android'): return (React.createElement(android_1.default, __assign({}, this.props)));
            case ('devices/apple'): return (React.createElement(apple_1.default, __assign({}, this.props)));
            case ('devices/arduino'): return (React.createElement(arduino_1.default, __assign({}, this.props)));
            case ('devices/blebox4'): return (React.createElement(blebox4_1.default, __assign({}, this.props)));
            case ('devices/blebox6'): return (React.createElement(blebox6_1.default, __assign({}, this.props)));
            case ('devices/bleRemote'): return (React.createElement(bleRemote_1.default, __assign({}, this.props)));
            case ('devices/bleRemote2'): return (React.createElement(bleRemote2_1.default, __assign({}, this.props)));
            case ('devices/bulb_hue'): return (React.createElement(bulb_hue_1.default, __assign({}, this.props)));
            case ('devices/bulb_lifx'): return (React.createElement(bulb_lifx_1.default, __assign({}, this.props)));
            case ('devices/bulb'): return (React.createElement(bulb_1.default, __assign({}, this.props)));
            case ('devices/coffeeMachine'): return (React.createElement(coffeeMachine_1.default, __assign({}, this.props)));
            case ('devices/conveyorBelt'): return (React.createElement(conveyorBelt_1.default, __assign({}, this.props)));
            case ('devices/desk'): return (React.createElement(desk_1.default, __assign({}, this.props)));
            case ('devices/devBoard'): return (React.createElement(devBoard_1.default, __assign({}, this.props)));
            case ('devices/dimmer'): return (React.createElement(dimmer_1.default, __assign({}, this.props)));
            case ('devices/dimmerOld'): return (React.createElement(dimmerOld_1.default, __assign({}, this.props)));
            case ('devices/dishwasher'): return (React.createElement(dishwasher_1.default, __assign({}, this.props)));
            case ('devices/doorSensor'): return (React.createElement(doorSensor_1.default, __assign({}, this.props)));
            case ('devices/drone'): return (React.createElement(drone_1.default, __assign({}, this.props)));
            case ('devices/echo'): return (React.createElement(echo_1.default, __assign({}, this.props)));
            case ('devices/echoDot'): return (React.createElement(echoDot_1.default, __assign({}, this.props)));
            case ('devices/esp'): return (React.createElement(esp_1.default, __assign({}, this.props)));
            case ('devices/fan'): return (React.createElement(fan_1.default, __assign({}, this.props)));
            case ('devices/firmata'): return (React.createElement(firmata_1.default, __assign({}, this.props)));
            case ('devices/fridge'): return (React.createElement(fridge_1.default, __assign({}, this.props)));
            case ('devices/genericDimmer'): return (React.createElement(genericDimmer_1.default, __assign({}, this.props)));
            case ('devices/genericSwitch'): return (React.createElement(genericSwitch_1.default, __assign({}, this.props)));
            case ('devices/googleHomeMini'): return (React.createElement(googleHomeMini_1.default, __assign({}, this.props)));
            case ('devices/haefeleHub'): return (React.createElement(haefeleHub_1.default, __assign({}, this.props)));
            case ('devices/hueBridge'): return (React.createElement(hueBridge_1.default, __assign({}, this.props)));
            case ('devices/hueDimmerRemote'): return (React.createElement(hueDimmerRemote_1.default, __assign({}, this.props)));
            case ('devices/hueLightSwitch'): return (React.createElement(hueLightSwitch_1.default, __assign({}, this.props)));
            case ('devices/ioLink'): return (React.createElement(ioLink_1.default, __assign({}, this.props)));
            case ('devices/kettle'): return (React.createElement(kettle_1.default, __assign({}, this.props)));
            case ('devices/KNX'): return (React.createElement(KNX_1.default, __assign({}, this.props)));
            case ('devices/lampDesk'): return (React.createElement(lampDesk_1.default, __assign({}, this.props)));
            case ('devices/lampStand'): return (React.createElement(lampStand_1.default, __assign({}, this.props)));
            case ('devices/lampTable'): return (React.createElement(lampTable_1.default, __assign({}, this.props)));
            case ('devices/lampTable2'): return (React.createElement(lampTable2_1.default, __assign({}, this.props)));
            case ('devices/lampWall'): return (React.createElement(lampWall_1.default, __assign({}, this.props)));
            case ('devices/ledband'): return (React.createElement(ledband_1.default, __assign({}, this.props)));
            case ('devices/lightingPadRound'): return (React.createElement(lightingPadRound_1.default, __assign({}, this.props)));
            case ('devices/lightingPadRoundDirect'): return (React.createElement(lightingPadRoundDirect_1.default, __assign({}, this.props)));
            case ('devices/lightingPadRoundIndirect'): return (React.createElement(lightingPadRoundIndirect_1.default, __assign({}, this.props)));
            case ('devices/lightingPadSquare'): return (React.createElement(lightingPadSquare_1.default, __assign({}, this.props)));
            case ('devices/lightingPadSquareDirect'): return (React.createElement(lightingPadSquareDirect_1.default, __assign({}, this.props)));
            case ('devices/lightingPadSquareIndirect'): return (React.createElement(lightingPadSquareIndirect_1.default, __assign({}, this.props)));
            case ('devices/lock'): return (React.createElement(lock_1.default, __assign({}, this.props)));
            case ('devices/lockOpen'): return (React.createElement(lockOpen_1.default, __assign({}, this.props)));
            case ('devices/lockTime'): return (React.createElement(lockTime_1.default, __assign({}, this.props)));
            case ('devices/meshbox2wire'): return (React.createElement(meshbox2wire_1.default, __assign({}, this.props)));
            case ('devices/meshboxEco'): return (React.createElement(meshboxEco_1.default, __assign({}, this.props)));
            case ('devices/meshboxEco1MW'): return (React.createElement(meshboxEco1MW_1.default, __assign({}, this.props)));
            case ('devices/meshboxEcoMW'): return (React.createElement(meshboxEcoMW_1.default, __assign({}, this.props)));
            case ('devices/meshboxEcoRGB'): return (React.createElement(meshboxEcoRGB_1.default, __assign({}, this.props)));
            case ('devices/meshThing'): return (React.createElement(meshThing_1.default, __assign({}, this.props)));
            case ('devices/meshthingNotification'): return (React.createElement(meshthingNotification_1.default, __assign({}, this.props)));
            case ('devices/microsoft'): return (React.createElement(microsoft_1.default, __assign({}, this.props)));
            case ('devices/microwave'): return (React.createElement(microwave_1.default, __assign({}, this.props)));
            case ('devices/mixer'): return (React.createElement(mixer_1.default, __assign({}, this.props)));
            case ('devices/motionSensor'): return (React.createElement(motionSensor_1.default, __assign({}, this.props)));
            case ('devices/motorElectric'): return (React.createElement(motorElectric_1.default, __assign({}, this.props)));
            case ('devices/movementSensor'): return (React.createElement(movementSensor_1.default, __assign({}, this.props)));
            case ('devices/MQTT'): return (React.createElement(MQTT_1.default, __assign({}, this.props)));
            case ('devices/multisensorPCB'): return (React.createElement(multisensorPCB_1.default, __assign({}, this.props)));
            case ('devices/multiwhite'): return (React.createElement(multiwhite_1.default, __assign({}, this.props)));
            case ('devices/nanopi'): return (React.createElement(nanopi_1.default, __assign({}, this.props)));
            case ('devices/nimbusModulQ'): return (React.createElement(nimbusModulQ_1.default, __assign({}, this.props)));
            case ('devices/nimbusRoxxane'): return (React.createElement(nimbusRoxxane_1.default, __assign({}, this.props)));
            case ('devices/nimbusWinglet'): return (React.createElement(nimbusWinglet_1.default, __assign({}, this.props)));
            case ('devices/nuimo'): return (React.createElement(nuimo_1.default, __assign({}, this.props)));
            case ('devices/OPCUA'): return (React.createElement(OPCUA_1.default, __assign({}, this.props)));
            case ('devices/oven'): return (React.createElement(oven_1.default, __assign({}, this.props)));
            case ('devices/printer3d'): return (React.createElement(printer3d_1.default, __assign({}, this.props)));
            case ('devices/radiator'): return (React.createElement(radiator_1.default, __assign({}, this.props)));
            case ('devices/remote'): return (React.createElement(remote_1.default, __assign({}, this.props)));
            case ('devices/remoteDirection'): return (React.createElement(remoteDirection_1.default, __assign({}, this.props)));
            case ('devices/remoteEco'): return (React.createElement(remoteEco_1.default, __assign({}, this.props)));
            case ('devices/remoteMovement'): return (React.createElement(remoteMovement_1.default, __assign({}, this.props)));
            case ('devices/rgb'): return (React.createElement(rgb_1.default, __assign({}, this.props)));
            case ('devices/robot'): return (React.createElement(robot_1.default, __assign({}, this.props)));
            case ('devices/robotVacuumCleaner'): return (React.createElement(robotVacuumCleaner_1.default, __assign({}, this.props)));
            case ('devices/ROS'): return (React.createElement(ROS_1.default, __assign({}, this.props)));
            case ('devices/scanner'): return (React.createElement(scanner_1.default, __assign({}, this.props)));
            case ('devices/slider'): return (React.createElement(slider_1.default, __assign({}, this.props)));
            case ('devices/slidingDoorLeft'): return (React.createElement(slidingDoorLeft_1.default, __assign({}, this.props)));
            case ('devices/slidingDoorRight'): return (React.createElement(slidingDoorRight_1.default, __assign({}, this.props)));
            case ('devices/smartphone'): return (React.createElement(smartphone_1.default, __assign({}, this.props)));
            case ('devices/smartwatch'): return (React.createElement(smartwatch_1.default, __assign({}, this.props)));
            case ('devices/socket'): return (React.createElement(socket_1.default, __assign({}, this.props)));
            case ('devices/speaker'): return (React.createElement(speaker_1.default, __assign({}, this.props)));
            case ('devices/spot'): return (React.createElement(spot_1.default, __assign({}, this.props)));
            case ('devices/spot2'): return (React.createElement(spot2_1.default, __assign({}, this.props)));
            case ('devices/steamer'): return (React.createElement(steamer_1.default, __assign({}, this.props)));
            case ('devices/stove'): return (React.createElement(stove_1.default, __assign({}, this.props)));
            case ('devices/streamdeck'): return (React.createElement(streamdeck_1.default, __assign({}, this.props)));
            case ('devices/switch'): return (React.createElement(switch_1.default, __assign({}, this.props)));
            case ('devices/switchDouble'): return (React.createElement(switchDouble_1.default, __assign({}, this.props)));
            case ('devices/switchDoubleLeft'): return (React.createElement(switchDoubleLeft_1.default, __assign({}, this.props)));
            case ('devices/switchDoubleRight'): return (React.createElement(switchDoubleRight_1.default, __assign({}, this.props)));
            case ('devices/switchTouch'): return (React.createElement(switchTouch_1.default, __assign({}, this.props)));
            case ('devices/tablet'): return (React.createElement(tablet_1.default, __assign({}, this.props)));
            case ('devices/tcp'): return (React.createElement(tcp_1.default, __assign({}, this.props)));
            case ('devices/thingosHub'): return (React.createElement(thingosHub_1.default, __assign({}, this.props)));
            case ('devices/toaster'): return (React.createElement(toaster_1.default, __assign({}, this.props)));
            case ('devices/toothbrush'): return (React.createElement(toothbrush_1.default, __assign({}, this.props)));
            case ('devices/tss'): return (React.createElement(tss_1.default, __assign({}, this.props)));
            case ('devices/tumbleDryer'): return (React.createElement(tumbleDryer_1.default, __assign({}, this.props)));
            case ('devices/tvHide'): return (React.createElement(tvHide_1.default, __assign({}, this.props)));
            case ('devices/tvLiftBackward'): return (React.createElement(tvLiftBackward_1.default, __assign({}, this.props)));
            case ('devices/tvLiftDown'): return (React.createElement(tvLiftDown_1.default, __assign({}, this.props)));
            case ('devices/tvLiftForward'): return (React.createElement(tvLiftForward_1.default, __assign({}, this.props)));
            case ('devices/tvLiftUp'): return (React.createElement(tvLiftUp_1.default, __assign({}, this.props)));
            case ('devices/tvReveal'): return (React.createElement(tvReveal_1.default, __assign({}, this.props)));
            case ('devices/UDP'): return (React.createElement(UDP_1.default, __assign({}, this.props)));
            case ('devices/usb'): return (React.createElement(usb_1.default, __assign({}, this.props)));
            case ('devices/wallcontrollerPCB'): return (React.createElement(wallcontrollerPCB_1.default, __assign({}, this.props)));
            case ('devices/wallSwitchHaefele'): return (React.createElement(wallSwitchHaefele_1.default, __assign({}, this.props)));
            case ('devices/wallSwitchHaefele1'): return (React.createElement(wallSwitchHaefele1_1.default, __assign({}, this.props)));
            case ('devices/wallSwitchHaefele2'): return (React.createElement(wallSwitchHaefele2_1.default, __assign({}, this.props)));
            case ('devices/wallSwitchHaefele3'): return (React.createElement(wallSwitchHaefele3_1.default, __assign({}, this.props)));
            case ('devices/wallSwitchHaefele4'): return (React.createElement(wallSwitchHaefele4_1.default, __assign({}, this.props)));
            case ('devices/wallSwitchHaefeleUS'): return (React.createElement(wallSwitchHaefeleUS_1.default, __assign({}, this.props)));
            case ('devices/wallSwitchHaefeleUS1'): return (React.createElement(wallSwitchHaefeleUS1_1.default, __assign({}, this.props)));
            case ('devices/wallSwitchHaefeleUS2'): return (React.createElement(wallSwitchHaefeleUS2_1.default, __assign({}, this.props)));
            case ('devices/wallSwitchHaefeleUS3'): return (React.createElement(wallSwitchHaefeleUS3_1.default, __assign({}, this.props)));
            case ('devices/wallSwitchHaefeleUS4'): return (React.createElement(wallSwitchHaefeleUS4_1.default, __assign({}, this.props)));
            case ('devices/wardrobeLift'): return (React.createElement(wardrobeLift_1.default, __assign({}, this.props)));
            case ('devices/washingMachine'): return (React.createElement(washingMachine_1.default, __assign({}, this.props)));
            case ('devices/webcam'): return (React.createElement(webcam_1.default, __assign({}, this.props)));
            case ('devices/windowSensor'): return (React.createElement(windowSensor_1.default, __assign({}, this.props)));
            case ('modules/accelerometer'): return (React.createElement(accelerometer_1.default, __assign({}, this.props)));
            case ('modules/analogIn'): return (React.createElement(analogIn_1.default, __assign({}, this.props)));
            case ('modules/analogOut'): return (React.createElement(analogOut_1.default, __assign({}, this.props)));
            case ('modules/ar'): return (React.createElement(ar_1.default, __assign({}, this.props)));
            case ('modules/audio'): return (React.createElement(audio_1.default, __assign({}, this.props)));
            case ('modules/barcodeScanner'): return (React.createElement(barcodeScanner_1.default, __assign({}, this.props)));
            case ('modules/battery'): return (React.createElement(battery_1.default, __assign({}, this.props)));
            case ('modules/bluetooth'): return (React.createElement(bluetooth_1.default, __assign({}, this.props)));
            case ('modules/brightness'): return (React.createElement(brightness_1.default, __assign({}, this.props)));
            case ('modules/button'): return (React.createElement(button_1.default, __assign({}, this.props)));
            case ('modules/circledIO'): return (React.createElement(circledIO_1.default, __assign({}, this.props)));
            case ('modules/color'): return (React.createElement(color_1.default, __assign({}, this.props)));
            case ('modules/communicationProtocol'): return (React.createElement(communicationProtocol_1.default, __assign({}, this.props)));
            case ('modules/contrast'): return (React.createElement(contrast_1.default, __assign({}, this.props)));
            case ('modules/deskDown'): return (React.createElement(deskDown_1.default, __assign({}, this.props)));
            case ('modules/deskUp'): return (React.createElement(deskUp_1.default, __assign({}, this.props)));
            case ('modules/digitalIn'): return (React.createElement(digitalIn_1.default, __assign({}, this.props)));
            case ('modules/digitalOut'): return (React.createElement(digitalOut_1.default, __assign({}, this.props)));
            case ('modules/dust'): return (React.createElement(dust_1.default, __assign({}, this.props)));
            case ('modules/electricity'): return (React.createElement(electricity_1.default, __assign({}, this.props)));
            case ('modules/fingerprint'): return (React.createElement(fingerprint_1.default, __assign({}, this.props)));
            case ('modules/genericIn'): return (React.createElement(genericIn_1.default, __assign({}, this.props)));
            case ('modules/genericOut'): return (React.createElement(genericOut_1.default, __assign({}, this.props)));
            case ('modules/group'): return (React.createElement(group_1.default, __assign({}, this.props)));
            case ('modules/gyroscope'): return (React.createElement(gyroscope_1.default, __assign({}, this.props)));
            case ('modules/heartrate'): return (React.createElement(heartrate_1.default, __assign({}, this.props)));
            case ('modules/humidity'): return (React.createElement(humidity_1.default, __assign({}, this.props)));
            case ('modules/joystick'): return (React.createElement(joystick_1.default, __assign({}, this.props)));
            case ('modules/location'): return (React.createElement(location_1.default, __assign({}, this.props)));
            case ('modules/magnet'): return (React.createElement(magnet_1.default, __assign({}, this.props)));
            case ('modules/magneticField'): return (React.createElement(magneticField_1.default, __assign({}, this.props)));
            case ('modules/motion'): return (React.createElement(motion_1.default, __assign({}, this.props)));
            case ('modules/nfc'): return (React.createElement(nfc_1.default, __assign({}, this.props)));
            case ('modules/notification'): return (React.createElement(notification_1.default, __assign({}, this.props)));
            case ('modules/pressure'): return (React.createElement(pressure_1.default, __assign({}, this.props)));
            case ('modules/proximity'): return (React.createElement(proximity_1.default, __assign({}, this.props)));
            case ('modules/pwm'): return (React.createElement(pwm_1.default, __assign({}, this.props)));
            case ('modules/qr'): return (React.createElement(qr_1.default, __assign({}, this.props)));
            case ('modules/rotation'): return (React.createElement(rotation_1.default, __assign({}, this.props)));
            case ('modules/signalRecieve'): return (React.createElement(signalRecieve_1.default, __assign({}, this.props)));
            case ('modules/signalSend'): return (React.createElement(signalSend_1.default, __assign({}, this.props)));
            case ('modules/smoke'): return (React.createElement(smoke_1.default, __assign({}, this.props)));
            case ('modules/speech'): return (React.createElement(speech_1.default, __assign({}, this.props)));
            case ('modules/squaredIO'): return (React.createElement(squaredIO_1.default, __assign({}, this.props)));
            case ('modules/switchPressed'): return (React.createElement(switchPressed_1.default, __assign({}, this.props)));
            case ('modules/switchReleased'): return (React.createElement(switchReleased_1.default, __assign({}, this.props)));
            case ('modules/tcpRead'): return (React.createElement(tcpRead_1.default, __assign({}, this.props)));
            case ('modules/tcpWrite'): return (React.createElement(tcpWrite_1.default, __assign({}, this.props)));
            case ('modules/temperature'): return (React.createElement(temperature_1.default, __assign({}, this.props)));
            case ('modules/time'): return (React.createElement(time_1.default, __assign({}, this.props)));
            case ('modules/touch'): return (React.createElement(touch_1.default, __assign({}, this.props)));
            case ('modules/usb'): return (React.createElement(usb_2.default, __assign({}, this.props)));
            case ('modules/usbIn'): return (React.createElement(usbIn_1.default, __assign({}, this.props)));
            case ('modules/usbOut'): return (React.createElement(usbOut_1.default, __assign({}, this.props)));
            case ('modules/webdisplay'): return (React.createElement(webdisplay_1.default, __assign({}, this.props)));
            case ('rooms/bathroom'): return (React.createElement(bathroom_1.default, __assign({}, this.props)));
            case ('rooms/bedroom'): return (React.createElement(bedroom_1.default, __assign({}, this.props)));
            case ('rooms/defaultroom'): return (React.createElement(defaultroom_1.default, __assign({}, this.props)));
            case ('rooms/deskroom'): return (React.createElement(deskroom_1.default, __assign({}, this.props)));
            case ('rooms/diningroom'): return (React.createElement(diningroom_1.default, __assign({}, this.props)));
            case ('rooms/dressingroom'): return (React.createElement(dressingroom_1.default, __assign({}, this.props)));
            case ('rooms/fitnessroom'): return (React.createElement(fitnessroom_1.default, __assign({}, this.props)));
            case ('rooms/garage'): return (React.createElement(garage_1.default, __assign({}, this.props)));
            case ('rooms/gazebo'): return (React.createElement(gazebo_1.default, __assign({}, this.props)));
            case ('rooms/kitchen'): return (React.createElement(kitchen_1.default, __assign({}, this.props)));
            case ('rooms/laundryroom'): return (React.createElement(laundryroom_1.default, __assign({}, this.props)));
            case ('rooms/livingroom'): return (React.createElement(livingroom_1.default, __assign({}, this.props)));
            case ('rooms/nursery'): return (React.createElement(nursery_1.default, __assign({}, this.props)));
            case ('rooms/toilet'): return (React.createElement(toilet_1.default, __assign({}, this.props)));
            case ('rooms/warehouse'): return (React.createElement(warehouse_1.default, __assign({}, this.props)));
            case ('services/alexa'): return (React.createElement(alexa_1.default, __assign({}, this.props)));
            case ('services/amazon'): return (React.createElement(amazon_1.default, __assign({}, this.props)));
            case ('services/bosch'): return (React.createElement(bosch_1.default, __assign({}, this.props)));
            case ('services/docker'): return (React.createElement(docker_1.default, __assign({}, this.props)));
            case ('services/facebook'): return (React.createElement(facebook_1.default, __assign({}, this.props)));
            case ('services/haefele'): return (React.createElement(haefele_1.default, __assign({}, this.props)));
            case ('services/hubApp'): return (React.createElement(hubApp_1.default, __assign({}, this.props)));
            case ('services/influxdata'): return (React.createElement(influxdata_1.default, __assign({}, this.props)));
            case ('services/linkedIn'): return (React.createElement(linkedIn_1.default, __assign({}, this.props)));
            case ('services/meshApp'): return (React.createElement(meshApp_1.default, __assign({}, this.props)));
            case ('services/naise'): return (React.createElement(naise_1.default, __assign({}, this.props)));
            case ('services/slack'): return (React.createElement(slack_1.default, __assign({}, this.props)));
            case ('services/thingos'): return (React.createElement(thingos_1.default, __assign({}, this.props)));
            case ('services/twitter'): return (React.createElement(twitter_1.default, __assign({}, this.props)));
            case ('services/windows'): return (React.createElement(windows_1.default, __assign({}, this.props)));
            case ('services/youtube'): return (React.createElement(youtube_1.default, __assign({}, this.props)));
            case ('ui/1Square'): return (React.createElement(_1Square_1.default, __assign({}, this.props)));
            case ('ui/2Square'): return (React.createElement(_2Square_1.default, __assign({}, this.props)));
            case ('ui/3Seconds'): return (React.createElement(_3Seconds_1.default, __assign({}, this.props)));
            case ('ui/3Square'): return (React.createElement(_3Square_1.default, __assign({}, this.props)));
            case ('ui/4Seconds'): return (React.createElement(_4Seconds_1.default, __assign({}, this.props)));
            case ('ui/4Square'): return (React.createElement(_4Square_1.default, __assign({}, this.props)));
            case ('ui/5Square'): return (React.createElement(_5Square_1.default, __assign({}, this.props)));
            case ('ui/6Square'): return (React.createElement(_6Square_1.default, __assign({}, this.props)));
            case ('ui/7Square'): return (React.createElement(_7Square_1.default, __assign({}, this.props)));
            case ('ui/8Square'): return (React.createElement(_8Square_1.default, __assign({}, this.props)));
            case ('ui/accuracy'): return (React.createElement(accuracy_1.default, __assign({}, this.props)));
            case ('ui/add'): return (React.createElement(add_1.default, __assign({}, this.props)));
            case ('ui/alert'): return (React.createElement(alert_1.default, __assign({}, this.props)));
            case ('ui/allDevices'): return (React.createElement(allDevices_1.default, __assign({}, this.props)));
            case ('ui/analyticsWeb'): return (React.createElement(analyticsWeb_1.default, __assign({}, this.props)));
            case ('ui/and'): return (React.createElement(and_1.default, __assign({}, this.props)));
            case ('ui/andSquare'): return (React.createElement(andSquare_1.default, __assign({}, this.props)));
            case ('ui/angle'): return (React.createElement(angle_1.default, __assign({}, this.props)));
            case ('ui/answers'): return (React.createElement(answers_1.default, __assign({}, this.props)));
            case ('ui/app'): return (React.createElement(app_1.default, __assign({}, this.props)));
            case ('ui/arrowDown'): return (React.createElement(arrowDown_1.default, __assign({}, this.props)));
            case ('ui/arrowLeft'): return (React.createElement(arrowLeft_1.default, __assign({}, this.props)));
            case ('ui/arrowRight'): return (React.createElement(arrowRight_1.default, __assign({}, this.props)));
            case ('ui/arrowUp'): return (React.createElement(arrowUp_1.default, __assign({}, this.props)));
            case ('ui/article'): return (React.createElement(article_1.default, __assign({}, this.props)));
            case ('ui/ASquare'): return (React.createElement(ASquare_1.default, __assign({}, this.props)));
            case ('ui/autoScrollSequence'): return (React.createElement(autoScrollSequence_1.default, __assign({}, this.props)));
            case ('ui/backup'): return (React.createElement(backup_1.default, __assign({}, this.props)));
            case ('ui/batteryEmpty'): return (React.createElement(batteryEmpty_1.default, __assign({}, this.props)));
            case ('ui/batteryFull'): return (React.createElement(batteryFull_1.default, __assign({}, this.props)));
            case ('ui/batteryMedium'): return (React.createElement(batteryMedium_1.default, __assign({}, this.props)));
            case ('ui/batteryStrong'): return (React.createElement(batteryStrong_1.default, __assign({}, this.props)));
            case ('ui/batteryUpdate'): return (React.createElement(batteryUpdate_1.default, __assign({}, this.props)));
            case ('ui/batteryWeak'): return (React.createElement(batteryWeak_1.default, __assign({}, this.props)));
            case ('ui/bin'): return (React.createElement(bin_1.default, __assign({}, this.props)));
            case ('ui/book'): return (React.createElement(book_1.default, __assign({}, this.props)));
            case ('ui/bookmark'): return (React.createElement(bookmark_1.default, __assign({}, this.props)));
            case ('ui/brightnessMinus'): return (React.createElement(brightnessMinus_1.default, __assign({}, this.props)));
            case ('ui/brightnessPlus'): return (React.createElement(brightnessPlus_1.default, __assign({}, this.props)));
            case ('ui/broadcast'): return (React.createElement(broadcast_1.default, __assign({}, this.props)));
            case ('ui/brush'): return (React.createElement(brush_1.default, __assign({}, this.props)));
            case ('ui/BSquare'): return (React.createElement(BSquare_1.default, __assign({}, this.props)));
            case ('ui/camera'): return (React.createElement(camera_1.default, __assign({}, this.props)));
            case ('ui/cancel'): return (React.createElement(cancel_1.default, __assign({}, this.props)));
            case ('ui/cart'): return (React.createElement(cart_1.default, __assign({}, this.props)));
            case ('ui/circle'): return (React.createElement(circle_1.default, __assign({}, this.props)));
            case ('ui/circledBackward'): return (React.createElement(circledBackward_1.default, __assign({}, this.props)));
            case ('ui/circledDone'): return (React.createElement(circledDone_1.default, __assign({}, this.props)));
            case ('ui/circledForeward'): return (React.createElement(circledForeward_1.default, __assign({}, this.props)));
            case ('ui/circledMinus'): return (React.createElement(circledMinus_1.default, __assign({}, this.props)));
            case ('ui/circledPause'): return (React.createElement(circledPause_1.default, __assign({}, this.props)));
            case ('ui/circledPlay'): return (React.createElement(circledPlay_1.default, __assign({}, this.props)));
            case ('ui/circledStop'): return (React.createElement(circledStop_1.default, __assign({}, this.props)));
            case ('ui/cloudDone'): return (React.createElement(cloudDone_1.default, __assign({}, this.props)));
            case ('ui/cloudDownload'): return (React.createElement(cloudDownload_1.default, __assign({}, this.props)));
            case ('ui/cloudError'): return (React.createElement(cloudError_1.default, __assign({}, this.props)));
            case ('ui/cloudUpload'): return (React.createElement(cloudUpload_1.default, __assign({}, this.props)));
            case ('ui/colorLeft'): return (React.createElement(colorLeft_1.default, __assign({}, this.props)));
            case ('ui/colorRight'): return (React.createElement(colorRight_1.default, __assign({}, this.props)));
            case ('ui/compress'): return (React.createElement(compress_1.default, __assign({}, this.props)));
            case ('ui/configuration'): return (React.createElement(configuration_1.default, __assign({}, this.props)));
            case ('ui/configurationSquare'): return (React.createElement(configurationSquare_1.default, __assign({}, this.props)));
            case ('ui/configurationTriangle'): return (React.createElement(configurationTriangle_1.default, __assign({}, this.props)));
            case ('ui/connected'): return (React.createElement(connected_1.default, __assign({}, this.props)));
            case ('ui/connectionEmpty'): return (React.createElement(connectionEmpty_1.default, __assign({}, this.props)));
            case ('ui/connectionError'): return (React.createElement(connectionError_1.default, __assign({}, this.props)));
            case ('ui/connectionMedium'): return (React.createElement(connectionMedium_1.default, __assign({}, this.props)));
            case ('ui/connectionStrong'): return (React.createElement(connectionStrong_1.default, __assign({}, this.props)));
            case ('ui/connectionWeak'): return (React.createElement(connectionWeak_1.default, __assign({}, this.props)));
            case ('ui/connectionWifiEmpty'): return (React.createElement(connectionWifiEmpty_1.default, __assign({}, this.props)));
            case ('ui/connectionWifiMedium'): return (React.createElement(connectionWifiMedium_1.default, __assign({}, this.props)));
            case ('ui/connectionWifiStrong'): return (React.createElement(connectionWifiStrong_1.default, __assign({}, this.props)));
            case ('ui/connectionWifiWeak'): return (React.createElement(connectionWifiWeak_1.default, __assign({}, this.props)));
            case ('ui/copy'): return (React.createElement(copy_1.default, __assign({}, this.props)));
            case ('ui/CSquare'): return (React.createElement(CSquare_1.default, __assign({}, this.props)));
            case ('ui/cubeOrthogonal'): return (React.createElement(cubeOrthogonal_1.default, __assign({}, this.props)));
            case ('ui/darkmode'): return (React.createElement(darkmode_1.default, __assign({}, this.props)));
            case ('ui/delete'): return (React.createElement(delete_1.default, __assign({}, this.props)));
            case ('ui/details'): return (React.createElement(details_1.default, __assign({}, this.props)));
            case ('ui/diamond'): return (React.createElement(diamond_1.default, __assign({}, this.props)));
            case ('ui/disconnected'): return (React.createElement(disconnected_1.default, __assign({}, this.props)));
            case ('ui/distance'): return (React.createElement(distance_1.default, __assign({}, this.props)));
            case ('ui/doctorsBag'): return (React.createElement(doctorsBag_1.default, __assign({}, this.props)));
            case ('ui/document'): return (React.createElement(document_1.default, __assign({}, this.props)));
            case ('ui/documentImage'): return (React.createElement(documentImage_1.default, __assign({}, this.props)));
            case ('ui/documents'): return (React.createElement(documents_1.default, __assign({}, this.props)));
            case ('ui/done'): return (React.createElement(done_1.default, __assign({}, this.props)));
            case ('ui/edit'): return (React.createElement(edit_1.default, __assign({}, this.props)));
            case ('ui/equal'): return (React.createElement(equal_1.default, __assign({}, this.props)));
            case ('ui/equalSquare'): return (React.createElement(equalSquare_1.default, __assign({}, this.props)));
            case ('ui/error'): return (React.createElement(error_1.default, __assign({}, this.props)));
            case ('ui/event'): return (React.createElement(event_1.default, __assign({}, this.props)));
            case ('ui/exchange'): return (React.createElement(exchange_1.default, __assign({}, this.props)));
            case ('ui/execute'): return (React.createElement(execute_1.default, __assign({}, this.props)));
            case ('ui/expand'): return (React.createElement(expand_1.default, __assign({}, this.props)));
            case ('ui/export'): return (React.createElement(export_1.default, __assign({}, this.props)));
            case ('ui/exportSequence'): return (React.createElement(exportSequence_1.default, __assign({}, this.props)));
            case ('ui/eye'): return (React.createElement(eye_1.default, __assign({}, this.props)));
            case ('ui/favorite'): return (React.createElement(favorite_1.default, __assign({}, this.props)));
            case ('ui/filter'): return (React.createElement(filter_1.default, __assign({}, this.props)));
            case ('ui/finish'): return (React.createElement(finish_1.default, __assign({}, this.props)));
            case ('ui/flashOff'): return (React.createElement(flashOff_1.default, __assign({}, this.props)));
            case ('ui/flashOn'): return (React.createElement(flashOn_1.default, __assign({}, this.props)));
            case ('ui/folder'): return (React.createElement(folder_1.default, __assign({}, this.props)));
            case ('ui/folderAdd'): return (React.createElement(folderAdd_1.default, __assign({}, this.props)));
            case ('ui/folderMove'): return (React.createElement(folderMove_1.default, __assign({}, this.props)));
            case ('ui/foodTruck'): return (React.createElement(foodTruck_1.default, __assign({}, this.props)));
            case ('ui/grid'): return (React.createElement(grid_1.default, __assign({}, this.props)));
            case ('ui/grove'): return (React.createElement(grove_1.default, __assign({}, this.props)));
            case ('ui/help'): return (React.createElement(help_1.default, __assign({}, this.props)));
            case ('ui/hide'): return (React.createElement(hide_1.default, __assign({}, this.props)));
            case ('ui/highPrice'): return (React.createElement(highPrice_1.default, __assign({}, this.props)));
            case ('ui/home'): return (React.createElement(home_1.default, __assign({}, this.props)));
            case ('ui/hsb'): return (React.createElement(hsb_1.default, __assign({}, this.props)));
            case ('ui/idea'): return (React.createElement(idea_1.default, __assign({}, this.props)));
            case ('ui/import'): return (React.createElement(import_1.default, __assign({}, this.props)));
            case ('ui/importSequence'): return (React.createElement(importSequence_1.default, __assign({}, this.props)));
            case ('ui/information'): return (React.createElement(information_1.default, __assign({}, this.props)));
            case ('ui/informationOff'): return (React.createElement(informationOff_1.default, __assign({}, this.props)));
            case ('ui/jumpTo'): return (React.createElement(jumpTo_1.default, __assign({}, this.props)));
            case ('ui/less'): return (React.createElement(less_1.default, __assign({}, this.props)));
            case ('ui/lessEqual'): return (React.createElement(lessEqual_1.default, __assign({}, this.props)));
            case ('ui/lessEqualSquare'): return (React.createElement(lessEqualSquare_1.default, __assign({}, this.props)));
            case ('ui/lessSquare'): return (React.createElement(lessSquare_1.default, __assign({}, this.props)));
            case ('ui/levels'): return (React.createElement(levels_1.default, __assign({}, this.props)));
            case ('ui/lightmode'): return (React.createElement(lightmode_1.default, __assign({}, this.props)));
            case ('ui/linechart'): return (React.createElement(linechart_1.default, __assign({}, this.props)));
            case ('ui/list'): return (React.createElement(list_1.default, __assign({}, this.props)));
            case ('ui/live'): return (React.createElement(live_1.default, __assign({}, this.props)));
            case ('ui/login'): return (React.createElement(login_1.default, __assign({}, this.props)));
            case ('ui/logout'): return (React.createElement(logout_1.default, __assign({}, this.props)));
            case ('ui/lowPrice'): return (React.createElement(lowPrice_1.default, __assign({}, this.props)));
            case ('ui/magic'): return (React.createElement(magic_1.default, __assign({}, this.props)));
            case ('ui/max'): return (React.createElement(max_1.default, __assign({}, this.props)));
            case ('ui/menuBurger'): return (React.createElement(menuBurger_1.default, __assign({}, this.props)));
            case ('ui/menuDots'): return (React.createElement(menuDots_1.default, __assign({}, this.props)));
            case ('ui/min'): return (React.createElement(min_1.default, __assign({}, this.props)));
            case ('ui/mirrorValue'): return (React.createElement(mirrorValue_1.default, __assign({}, this.props)));
            case ('ui/moon'): return (React.createElement(moon_1.default, __assign({}, this.props)));
            case ('ui/more'): return (React.createElement(more_1.default, __assign({}, this.props)));
            case ('ui/moreEqual'): return (React.createElement(moreEqual_1.default, __assign({}, this.props)));
            case ('ui/moreEqualSquare'): return (React.createElement(moreEqualSquare_1.default, __assign({}, this.props)));
            case ('ui/moreSquare'): return (React.createElement(moreSquare_1.default, __assign({}, this.props)));
            case ('ui/networkDecentral'): return (React.createElement(networkDecentral_1.default, __assign({}, this.props)));
            case ('ui/networkDecentralSetup'): return (React.createElement(networkDecentralSetup_1.default, __assign({}, this.props)));
            case ('ui/networkHub'): return (React.createElement(networkHub_1.default, __assign({}, this.props)));
            case ('ui/new'): return (React.createElement(new_1.default, __assign({}, this.props)));
            case ('ui/noHub'): return (React.createElement(noHub_1.default, __assign({}, this.props)));
            case ('ui/notEqual'): return (React.createElement(notEqual_1.default, __assign({}, this.props)));
            case ('ui/notEqualSquare'): return (React.createElement(notEqualSquare_1.default, __assign({}, this.props)));
            case ('ui/off'): return (React.createElement(off_1.default, __assign({}, this.props)));
            case ('ui/on'): return (React.createElement(on_1.default, __assign({}, this.props)));
            case ('ui/openStandard'): return (React.createElement(openStandard_1.default, __assign({}, this.props)));
            case ('ui/or'): return (React.createElement(or_1.default, __assign({}, this.props)));
            case ('ui/orSquare'): return (React.createElement(orSquare_1.default, __assign({}, this.props)));
            case ('ui/palette'): return (React.createElement(palette_1.default, __assign({}, this.props)));
            case ('ui/paste'): return (React.createElement(paste_1.default, __assign({}, this.props)));
            case ('ui/pasteText'): return (React.createElement(pasteText_1.default, __assign({}, this.props)));
            case ('ui/pause'): return (React.createElement(pause_1.default, __assign({}, this.props)));
            case ('ui/person'): return (React.createElement(person_1.default, __assign({}, this.props)));
            case ('ui/pin'): return (React.createElement(pin_1.default, __assign({}, this.props)));
            case ('ui/play'): return (React.createElement(play_1.default, __assign({}, this.props)));
            case ('ui/plugins'): return (React.createElement(plugins_1.default, __assign({}, this.props)));
            case ('ui/puzzle'): return (React.createElement(puzzle_1.default, __assign({}, this.props)));
            case ('ui/questions'): return (React.createElement(questions_1.default, __assign({}, this.props)));
            case ('ui/rain'): return (React.createElement(rain_1.default, __assign({}, this.props)));
            case ('ui/redo'): return (React.createElement(redo_1.default, __assign({}, this.props)));
            case ('ui/reference'): return (React.createElement(reference_1.default, __assign({}, this.props)));
            case ('ui/refresh'): return (React.createElement(refresh_1.default, __assign({}, this.props)));
            case ('ui/removeNetworkDecentral'): return (React.createElement(removeNetworkDecentral_1.default, __assign({}, this.props)));
            case ('ui/removePerson'): return (React.createElement(removePerson_1.default, __assign({}, this.props)));
            case ('ui/removeShop'): return (React.createElement(removeShop_1.default, __assign({}, this.props)));
            case ('ui/reorder'): return (React.createElement(reorder_1.default, __assign({}, this.props)));
            case ('ui/reset'): return (React.createElement(reset_1.default, __assign({}, this.props)));
            case ('ui/resolution'): return (React.createElement(resolution_1.default, __assign({}, this.props)));
            case ('ui/restart'): return (React.createElement(restart_1.default, __assign({}, this.props)));
            case ('ui/rgb'): return (React.createElement(rgb_2.default, __assign({}, this.props)));
            case ('ui/row'): return (React.createElement(row_1.default, __assign({}, this.props)));
            case ('ui/rule'): return (React.createElement(rule_1.default, __assign({}, this.props)));
            case ('ui/running'): return (React.createElement(running_1.default, __assign({}, this.props)));
            case ('ui/saturationMinus'): return (React.createElement(saturationMinus_1.default, __assign({}, this.props)));
            case ('ui/saturationPlus'): return (React.createElement(saturationPlus_1.default, __assign({}, this.props)));
            case ('ui/save'): return (React.createElement(save_1.default, __assign({}, this.props)));
            case ('ui/saveNext'): return (React.createElement(saveNext_1.default, __assign({}, this.props)));
            case ('ui/scene'): return (React.createElement(scene_1.default, __assign({}, this.props)));
            case ('ui/search'): return (React.createElement(search_1.default, __assign({}, this.props)));
            case ('ui/searchList'): return (React.createElement(searchList_1.default, __assign({}, this.props)));
            case ('ui/searchSquare'): return (React.createElement(searchSquare_1.default, __assign({}, this.props)));
            case ('ui/securityChecked'): return (React.createElement(securityChecked_1.default, __assign({}, this.props)));
            case ('ui/sensor'): return (React.createElement(sensor_1.default, __assign({}, this.props)));
            case ('ui/settings'): return (React.createElement(settings_1.default, __assign({}, this.props)));
            case ('ui/share'): return (React.createElement(share_1.default, __assign({}, this.props)));
            case ('ui/shareIOS'): return (React.createElement(shareIOS_1.default, __assign({}, this.props)));
            case ('ui/shop'): return (React.createElement(shop_1.default, __assign({}, this.props)));
            case ('ui/shutdown'): return (React.createElement(shutdown_1.default, __assign({}, this.props)));
            case ('ui/smarthome'): return (React.createElement(smarthome_1.default, __assign({}, this.props)));
            case ('ui/snow'): return (React.createElement(snow_1.default, __assign({}, this.props)));
            case ('ui/sortAlphabetically'): return (React.createElement(sortAlphabetically_1.default, __assign({}, this.props)));
            case ('ui/sortByDevice'): return (React.createElement(sortByDevice_1.default, __assign({}, this.props)));
            case ('ui/sortByDeviceIndustrial'): return (React.createElement(sortByDeviceIndustrial_1.default, __assign({}, this.props)));
            case ('ui/speechBubble'): return (React.createElement(speechBubble_1.default, __assign({}, this.props)));
            case ('ui/speed'): return (React.createElement(speed_1.default, __assign({}, this.props)));
            case ('ui/starEdit'): return (React.createElement(starEdit_1.default, __assign({}, this.props)));
            case ('ui/starEmpty'): return (React.createElement(starEmpty_1.default, __assign({}, this.props)));
            case ('ui/starFull'): return (React.createElement(starFull_1.default, __assign({}, this.props)));
            case ('ui/starHalf'): return (React.createElement(starHalf_1.default, __assign({}, this.props)));
            case ('ui/statistics'): return (React.createElement(statistics_1.default, __assign({}, this.props)));
            case ('ui/stethoscope'): return (React.createElement(stethoscope_1.default, __assign({}, this.props)));
            case ('ui/structure'): return (React.createElement(structure_1.default, __assign({}, this.props)));
            case ('ui/suitcase'): return (React.createElement(suitcase_1.default, __assign({}, this.props)));
            case ('ui/sun'): return (React.createElement(sun_1.default, __assign({}, this.props)));
            case ('ui/sunriseHouse'): return (React.createElement(sunriseHouse_1.default, __assign({}, this.props)));
            case ('ui/sunset'): return (React.createElement(sunset_1.default, __assign({}, this.props)));
            case ('ui/temperatureMinus'): return (React.createElement(temperatureMinus_1.default, __assign({}, this.props)));
            case ('ui/temperaturePlus'): return (React.createElement(temperaturePlus_1.default, __assign({}, this.props)));
            case ('ui/time'): return (React.createElement(time_2.default, __assign({}, this.props)));
            case ('ui/timeBackward'): return (React.createElement(timeBackward_1.default, __assign({}, this.props)));
            case ('ui/timeForward'): return (React.createElement(timeForward_1.default, __assign({}, this.props)));
            case ('ui/toggle'): return (React.createElement(toggle_1.default, __assign({}, this.props)));
            case ('ui/tool'): return (React.createElement(tool_1.default, __assign({}, this.props)));
            case ('ui/training'): return (React.createElement(training_1.default, __assign({}, this.props)));
            case ('ui/translate'): return (React.createElement(translate_1.default, __assign({}, this.props)));
            case ('ui/umbrella'): return (React.createElement(umbrella_1.default, __assign({}, this.props)));
            case ('ui/undo'): return (React.createElement(undo_1.default, __assign({}, this.props)));
            case ('ui/update'): return (React.createElement(update_1.default, __assign({}, this.props)));
            case ('ui/virtual'): return (React.createElement(virtual_1.default, __assign({}, this.props)));
            case ('ui/windowConsole'): return (React.createElement(windowConsole_1.default, __assign({}, this.props)));
            case ('ui/windowList'): return (React.createElement(windowList_1.default, __assign({}, this.props)));
            case ('ui/windowSettings'): return (React.createElement(windowSettings_1.default, __assign({}, this.props)));
            case ('ui/workflow'): return (React.createElement(workflow_1.default, __assign({}, this.props)));
            case ('ui/world'): return (React.createElement(world_1.default, __assign({}, this.props)));
            default: return null;
        }
    };
    Icon.kindList = iconList;
    Icon.defaultProps = {
        width: "24",
        height: "24",
        color: "#000"
    };
    return Icon;
}(React.Component));
exports.default = Icon;
